import { render, staticRenderFns } from "./StatInspFilter.vue?vue&type=template&id=97a88c80"
import script from "./StatInspFilter.vue?vue&type=script&lang=js"
export * from "./StatInspFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports